export default __webpack_public_path__ + "static/media/J730_CoC.26891146.pdf";